import { useEffect, useMemo } from 'react';

import { useNavigate, useParams } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { PageHeader, Button } from '@app-velocity/ui';

import { useRouterContext } from '../../router/useRouterContext';

export const AuthFailurePage = () => {
  const { type } = useParams<{ type: 'figma' | 'google' }>();
  const { t } = useI18n();
  const { strategy } = useRouterContext();

  const navigate = useNavigate();

  const storedKey = useMemo(() => {
    if (strategy !== 'WEB_APP') return '';

    return window.sessionStorage.getItem('readKey');
  }, []);

  useEffect(() => {
    if (!storedKey) return;
    window.sessionStorage.removeItem('readKey');
  }, [storedKey]);

  const goToHomePage = () => {
    navigate('/');
  };

  if (!type) return;

  return (
    <>
      <PageHeader>
        <PageHeader.Title>{t('users:auth.failure')}</PageHeader.Title>
        <PageHeader.Subtitle>
          {t(`users:auth.${type}_failure`)}
        </PageHeader.Subtitle>
      </PageHeader>
      {/* key is stored in storage only on web portal */}
      {/* {storedKey ? ( */}
      <Button
        size="large"
        fullWidth
        variant="contained"
        color="primary"
        onClick={goToHomePage}
      >
        {t('users:go_back_to_sign_in')}
      </Button>
      {/* ) : undefined} */}
    </>
  );
};
